import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import { WEBAPP_ROUTE_PREFIX } from '../../../constants/route'
import { useInitData, useLinkLikeClick } from '../../../hooks'
import { getBuildingProfilePathname } from '../../../utils/link'
import { ListItem } from '../../ListItem'

import { isNeedToShowBuildingItemIcons } from './ProfileBuildingsWidgetItem.utils'

import * as styles from './ProfileBuildingsWidgetItem.module.css'

import BuildingIcon from '../../../icons/building.svg'

function ProfileBuildingsWidgetItem({
  className = styles.ProfileBuildingsWidgetItem,
  hoverClassName = styles.hover,
  isNeedToShowIcons = isNeedToShowBuildingItemIcons,
  target,
  ...restProps
}) {
  const { handleClick } = useLinkLikeClick()

  const { availableSections } = useInitData()

  function handleClickBuilding(id) {
    const link = getBuildingProfilePathname({ availableSections, id })

    handleClick({
      link,
      // Webapp fallback keeps opening in a new tab; NG profile navigates in-app.
      outsideLink: link.includes(WEBAPP_ROUTE_PREFIX),
      target,
    })
  }

  return (
    <ListItem
      {...restProps}
      ListIcon={BuildingIcon}
      className={className}
      hoverClassName={hoverClassName}
      isNeedToShowIcons={isNeedToShowIcons}
      textClassName={styles.text}
      tooltipProps={{ placement: FLOATING_ELEMENT_PLACEMENT.top }}
      onClick={handleClickBuilding}
    />
  )
}

export default ProfileBuildingsWidgetItem
